// Copyright (c) Ping. All rights reserved.
//
// Dexie `ConversationStore` adapter for MLS orchestration. Split from
// mlsConversation.ts so unit tests can import it without pulling the
// full @ping/ui barrel (which loads RN-only modules under Vitest).

import { memberAccountSetsEqual } from '@ping/ui/src/conversation/groupConversation';
import type { ConversationStore } from '@ping/ui/src/conversation/mlsConversation';

import { db } from '@core/persistence/db';

export const webConversationsAdapter: ConversationStore = {
  async get(localId) {
    const row = await db.conversations.get(localId);
    if (!row) return undefined;
    const base = {
      kind: row.kind,
      ...(row.name !== undefined ? { name: row.name } : {}),
    };
    if (row.kind === 'group') {
      return row.memberAccountIds !== undefined
        ? { ...base, memberAccountIds: row.memberAccountIds }
        : base;
    }
    return row.peerAccountId !== undefined
      ? { ...base, peerAccountId: row.peerAccountId }
      : base;
  },

  async findGroupByPeerAccountIds(peerAccountIds) {
    const normalized = [...peerAccountIds].sort();
    const groups = await db.conversations.where('kind').equals('group').toArray();
    for (const row of groups) {
      if (!row.memberAccountIds) continue;
      const rowNormalized = [...row.memberAccountIds].sort();
      if (memberAccountSetsEqual(rowNormalized, normalized)) {
        return row.id;
      }
    }
    return undefined;
  },

  async listGroupConversations() {
    const groups = await db.conversations.where('kind').equals('group').toArray();
    return groups.map((row) => ({
      id: row.id,
      kind: row.kind,
      ...(row.memberAccountIds !== undefined
        ? { memberAccountIds: row.memberAccountIds }
        : {}),
    }));
  },
};
